import PropTypes from 'prop-types'
import React from 'react'

import { Tooltip, TooltipBody } from 'react-wot-bootstrap'

import { SCHEDULE_TYPES } from 'constants'

import {
    FORT_BATTLES_ON_PERIPHERY_OVERRIDDEN,
    SORTIES_BY_VEHICLE_LEVEL_ON_PERIPHERY_OVERRIDDEN,
} from './translations'

const BattleModeAtPeripheryOverriddenTooltip = (props) => {
    let message
    if (props.battleMode === SCHEDULE_TYPES.SORTIE) {
        message = SORTIES_BY_VEHICLE_LEVEL_ON_PERIPHERY_OVERRIDDEN(
            props.vehicleLevel,
            props.peripheryName,
            props.isDisabled,
        )
    } else {
        message = FORT_BATTLES_ON_PERIPHERY_OVERRIDDEN(props.peripheryName, props.isDisabled)
    }
    return (
        <Tooltip isWide id={props.id}>
            <TooltipBody>
                {message}
            </TooltipBody>
        </Tooltip>
    )
}

BattleModeAtPeripheryOverriddenTooltip.propTypes = {
    id: PropTypes.string.isRequired,
    peripheryName: PropTypes.string.isRequired,
    vehicleLevel: PropTypes.number,
    battleMode: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool.isRequired,
}

export default BattleModeAtPeripheryOverriddenTooltip


// WEBPACK FOOTER //
// ./containers/Schedule/components/ScheduleTable/tooltips/BattleModeAtPeripheryOverriddenTooltip.jsx